const IMAGEKIT_BASE = "https://ik.imagekit.io/officehub";

export const LISTING_CARD_IMAGE_SIZES = "(max-width: 768px) 92vw, 400px";

export function listingCardImageSrc(path: string, width: 400 | 800 = 800): string {
  const clean = String(path || "").replace(/^\//, "");
  const transform =
    width === 400
      ? "tr:h-250,w-400,q-70,f-avif"
      : "tr:h-500,w-800,q-70,f-avif";
  return `${IMAGEKIT_BASE}/${transform}/${clean}`;
}

export function listingCardImageSrcSet(path: string): string {
  return `${listingCardImageSrc(path, 400)} 400w, ${listingCardImageSrc(path, 800)} 800w`;
}

export function listingCardLcpPreloadLinks(path?: string) {
  if (!path) return [];
  return [
    {
      tagName: "link",
      rel: "preload",
      as: "image",
      href: listingCardImageSrc(path, 800),
      imageSrcSet: listingCardImageSrcSet(path),
      imageSizes: LISTING_CARD_IMAGE_SIZES,
      fetchpriority: "high",
    },
  ];
}
